import { createHashHistory, createMemoryHistory } from 'history';

export const history =
  process.env.NODE_ENV !== 'test' ? createHashHistory() : createMemoryHistory();
